import { Component, Input, OnInit } from '@angular/core';
import { DATE_FORMAT } from 'src/app/shared/constants/date-format';
import { Allowance } from 'src/app/shared/models/allowance.model';
import { Parking } from 'src/app/shared/models/parking.model';
import { Nullable } from 'src/app/shared/constants/types'

@Component({
  selector: 'app-parking-form',
  templateUrl: './parking-form.component.html',
  styleUrls: ['./parking-form.component.scss'],
})
export class ParkingFormComponent {
  @Input() public parkings: Parking[] = [];
  @Input() public editable = false;
  public readonly DATE_FORMAT = DATE_FORMAT;


	getModificationDate(parking:Parking ) : Nullable<Date> {
		return (parking)?parking.modificationDate:null;
	}
}
